import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsappFab from "@/components/WhatsappFab";
import CookieBanner from "@/components/CookieBanner";
import Analytics from "@/components/Analytics";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import NettoyagePremium from "@/pages/NettoyagePremium";
import Polissage from "@/pages/Polissage";
import Ceramique from "@/pages/Ceramique";
import Galerie from "@/pages/Galerie";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import Confirmation from "@/pages/Confirmation";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import CGV from "@/pages/CGV";
import AppErrorBoundary from "@/components/AppErrorBoundary";

function App() {
  return (
    <div className="App">
      <AppErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nettoyage-automobile-premium" element={<NettoyagePremium />} />
          <Route path="/polissage-automobile" element={<Polissage />} />
          <Route path="/traitement-ceramique" element={<Ceramique />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/demande-envoyee" element={<Confirmation />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<Confidentialite />} />
          <Route path="/cgv" element={<CGV />} />
        </Routes>
        <Footer />
        <WhatsappFab />
        <CookieBanner />
        <Analytics />
      </BrowserRouter>
      </AppErrorBoundary>
      <Toaster
        theme="dark"
        position="bottom-left"
        toastOptions={{
          style: {
            background: "#0d0d0d",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
